<script setup lang = "ts">
import {Money3Component} from "v-money3";
import type {PropType} from "vue";
import type {QField, ValidationRule} from "quasar";

const model = defineModel<string | number | null>()
const emit = defineEmits(['update:modelValue'])

const inputRef = ref<QField | null>(null);

const selectAll = () => {
	if (inputRef.value) {
		inputRef.value.$el.querySelectorAll("input")[0].select()
	}
}


defineProps({
	rules: {type: Object as PropType<ValidationRule[]>, required: false},
	append: {type: String, required: false},
	suffix: {type: String, required: false},
	label: {type: String},
	readonly: {type: Boolean, required: false},
	dense: {type: Boolean, required: false},
	color: {type: String, required: false},
	classInput: {type: String, required: false},
	square: {type: Boolean, required: false},
	borderless: {type: Boolean, required: false},
	hint: {type: String, required: false},
})

const moneyFormatConfig = {
	prefix: '',
	suffix: '',
	thousands: ',',
	decimal: '.',
	precision: 0,
	disableNegative: true,
	disabled: false,
	allowBlank: false,
	minimumNumberOfCharacters: 0,
	shouldRound: true,
	focusOnRight: true,
}
</script>

<template>
	<q-field :outlined = "!borderless"
					 v-model = "model"
					 :rules = "rules"
					 ref = "inputRef"
					 :suffix = "suffix"
					 :class = "classInput"
					 :readonly = "readonly"
					 :hint="hint"
					 lazy-rules
					 :dense = "dense"
					 :disable="readonly"
					 :color = "color"
					 :square = "square"
					 :borderless = "borderless"
					 @input = "emit('update:modelValue',$event.target.value)"
					 :label = "label">
		<template v-slot:control = "{ id, floatingLabel, modelValue, emitValue }">
			<money3-component :id = "id" class = "q-field__input text-right"
												:model-value = "modelValue"
												@update:model-value = "emitValue"
												v-bind = "moneyFormatConfig"
												@click = "selectAll"
												v-show = "floatingLabel"
			/>
		</template>
		<template v-if = "!!append" v-slot:append>
			<span class = "text-base font-light">{{ append }}</span>
		</template>
	</q-field>
</template>

<style scoped>

</style>